import clsx from 'clsx';
import styles from './Text.module.scss';
import { type ReactNode } from 'react';

type TextColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info';

type TextVariant = 'default' | 'monospace';

interface Props {
  children: ReactNode;
  color?: TextColor;
  variant?: TextVariant;
}

export function Text({
  children,
  color = 'primary',
  variant = 'default',
}: Props) {
  return (
    <span
      className={clsx(
        styles['text'],
        styles[`text-color-${color}`],
        variant === 'monospace' && styles['text-variant-monospace'],
      )}
    >
      {children}
    </span>
  );
}
